import React from 'react';

export const BooleanTableCell = (props: { value: boolean }) => {
  const { value } = props;
  return value ? <>Yes</> : <>No</>;
};
